// @ts-nocheck
import React from 'react';
import { Dialog, Button } from '@blueprintjs/core';
import '@/style/containers/InventoryTypeDialog/style.scss';

export type InventoryType = 'ostk' | 'sinv';

export default function InventoryTypeDialog({
  isOpen,
  itemName,
  onSelect,
  onClose,
}: {
  isOpen: boolean;
  itemName?: string | null;
  onSelect: (type: InventoryType) => void;
  onClose: () => void;
}) {
  return (
    <Dialog
      isOpen={isOpen}
      onClose={onClose}
      canOutsideClickClose={true}
      style={{maxWidth: '420px'}}
      canEscapeKeyClose={true}
    >
      <div className='inventory-type-dialog'>
        <div className='inventory-type-dialog__header'>
          <span>?</span>
        </div>
        <div className='inventory-type-dialog__content'>
          <h2 className='inventory-type-dialog__title'>Choose how you would like to fulfill this item?</h2>
          <Button className='inventory-type-dialog__ordering-stock-btn' onClick={() => onSelect('ostk')}>
            Ordering for stock
          </Button>
          <Button className='inventory-type-dialog__shipping-inventory-btn' onClick={() => onSelect('sinv')}>
            Shipping from inventory
          </Button>
          <Button onClick={onClose} className='inventory-type-dialog__cancel-btn'>
            Cancel
          </Button>
        </div>
      </div>
    </Dialog>
  );
}

